import React from 'react'
import classNames from 'classnames'

import styles from '../component-styles/heading.module.scss'

interface Props {
  type?: number
  children?: React.ReactNode
  className?: string
  style?: object
  align?: 'center' | 'left' | 'right'
}

export default function Heading({
  type,
  children,
  className,
  align,
  style,
  ...props
}: Props): React.ReactElement {
  const c = classNames(className, styles.heading)

  switch (type) {
    case 1:
      return (
        <h1
          className={c}
          style={{ ...style, textAlign: align, marginTop: 0 }}
          {...props}
        >
          {children}
        </h1>
      )
    case 2:
      return (
        <h2 className={c} style={{ ...style, textAlign: align }} {...props}>
          {children}
        </h2>
      )
    case 3:
      return (
        <h3 className={c} style={{ ...style, textAlign: align }} {...props}>
          {children}
        </h3>
      )
    case 4:
      return (
        <h4 className={c} style={{ ...style, textAlign: align }} {...props}>
          {children}
        </h4>
      )
    case 5:
      return (
        <h5 className={c} style={{ ...style, textAlign: align }} {...props}>
          {children}
        </h5>
      )
    default:
      return (
        <h3 className={c} style={{ ...style, textAlign: align }} {...props}>
          {children}
        </h3>
      )
  }
}

Heading.defaultProps = {
  align: 'center',
  style: {},
}
